<template>
  <div class="common-alarm-bg">
    <div class="common-alarm-div" ref="overSpeedAlarm">
      <el-form
        :model="dataInfo"
        ref="form"
        :rules="dataInfoRules"
        label-width="80px"
      >
        <table class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td colspan="3">
              <el-tag type="warning"
                ><i class="el-icon-warning"></i
                >&nbsp;&nbsp;&nbsp;道路划分为高速路，快速路，普通路，每类道路设置速度上限值和持续时长。当车辆速度持续超过速度上限值并达到持续时长，产生超速报警。
              </el-tag>
            </td>
          </tr>
          <tr>
            <td>
              <p>是否启用</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isApply"
                  @change="isApplyChange"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>设置启用为“否”，该项报警设置暂时无效，直到重新启用。</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>超高速</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.isHighSpeed"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.judgePattern"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel0">自定义限速</el-radio>
                  <el-radio :label="radioLabel1">道路规定限速</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="hHighWaySpeed">
                <el-input
                  v-model="dataInfo.hHighWaySpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">高速路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="hFastRoadSpeed">
                <el-input
                  v-model="dataInfo.hFastRoadSpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">快速路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>

              <el-form-item prop="hGeneralRoadSpeed">
                <el-input
                  v-model="dataInfo.hGeneralRoadSpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">普通路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="hContinueTime">
                <el-input
                  v-model="dataInfo.hContinueTime"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">&nbsp;&nbsp;&nbsp;持续时间</template>
                  <template slot="append"
                    >s&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</template
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="dangerSpeed">
                <el-input
                  v-model="dataInfo.dangerSpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">&nbsp;&nbsp;&nbsp;危险速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
            </td>
            <td>
              <p>车辆一旦超过危险速度，立即报警</p>
              <p>
                自定义限速为客户自己设置超速速度判断超速，道路规定限速为平台获取所在道路规定的超速速度判断超速
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>适用范围</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isOverAll"
                  :disabled="alarmSetId == 0 ? false : true"
                >
                  <el-radio :label="radioLabel1">全局设置</el-radio>
                  <el-radio :label="radioLabel0">自定义车辆</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="alarmSetId == 0">
                <e6Select
                  :dataList="vehicleTreeList"
                  :filterable="true"
                  slotTemplate="tree"
                  :issingleleaf="true"
                  multiple
                  ref="e6select"
                  :disabled="
                    dataInfo.alarmCommonAlarmSet.isOverAll == 1 ? true : false
                  "
                  :placeholder="'请选择车辆'"
                >
                </e6Select>
              </el-form-item>
              <el-form-item v-if="alarmSetId != 0">
                <el-input
                  v-model="dataInfo.vehicleNo"
                  size="small"
                  class="alarm-form-input"
                  :disabled="true"
                />
              </el-form-item>
            </td>
            <td>
              <p>
                对指定车辆自定义设置，选择的车辆按照所设置参数进行报警业务判断。若车辆某项报警进行了自定义设置，全局设置参数针对此车不起作用。
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <el-button type="text" @click="switchSetting">
                <i
                  :class="[
                    advancedSettingShow
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  ]"
                ></i
                >{{ switchSettingBtnText }}
              </el-button>
            </td>
          </tr>
        </table>

        <table v-show="advancedSettingShow" class="alarm-table">
          <colgroup>
            <col style="width: 5%" />
            <col style="width: 30%" />
            <col style="width: 65%" />
          </colgroup>
          <tr>
            <td>
              <p>超低速</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.isLowSpeed"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="dataInfo.lHighWaySpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">高速路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="dataInfo.lFastRoadSpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">快速路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="dataInfo.lGeneralRoadSpeed"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">普通路速度</template>
                  <template slot="append">km/h</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="dataInfo.lContinueTime"
                  size="small"
                  class="alarm-form-input"
                  :disabled="disabledByApply"
                >
                  <template slot="prepend">&nbsp;&nbsp;&nbsp;持续时间</template>
                  <template slot="append"
                    >s&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</template
                  >
                </el-input>
              </el-form-item>
            </td>
            <td>
              <p>车辆低于设置速度时产生超低速报警</p>
            </td>
          </tr>
          <!-- <tr>
            <td>
              <p>平台显示</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPlateformShow"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置平台显示为“否”，报警处理及报警报表中记录报警信息，但是报警提示框与车辆定位监控不显示发生的报警信息。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>警音提醒</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isAlarmSound"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                设置警音提醒显示为“是”，当发生报警的时候，平台会有警音提醒。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>通知终端</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isTerminalShow"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel1">是</el-radio>
                  <el-radio :label="radioLabel0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                若设置邮件提醒，当发生报警时将报警信息通过邮件方式发送给联系人。若您开通了短信提醒，设置短信提醒，当发生报警时将报警信息通过手机短信发送给联系人。若设置了微信通知，并且联系人绑定了微信号，当发生报警时将报警信息通过服务号发送给联系人。现在就去设置。
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>闪拍</p>
            </td>
            <td>
              <el-form-item>
                <el-radio-group
                  v-model="dataInfo.alarmCommonAlarmSet.isPhoto"
                  :disabled="disabledByApply"
                >
                  <el-radio :label="radioLabel0">关闭</el-radio>
                  <el-radio :label="radioLabel1">开启-拍照</el-radio>
                  <el-radio :label="radioLabel2">开启-10s短视频</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
            <td>
              <p>
                若选择开启，发生报警时，可抓拍照片或录制10s短视频（需安装摄像头）。
              </p>
            </td>
          </tr> -->
        </table>
      </el-form>
    </div>
    <div class="text-c mt30 common-alarm-btndiv">
      <el-button type="primary" @click="addData()" :loading="loadingState"
        >保存</el-button
      >
      <el-button @click="cancelSubmit()">取消</el-button>
    </div>
  </div>
</template>

<script>
import e6Select from "e6select";
import {
  FetchSaveOverSpeedAlarmSet,
  FetchFindOverSpeedAlarmById,
  FetchUpdateOverSpeedAlarmSet
} from "@/api/alarmSet/commonAlarmSet";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { validatorIntNum } from "@/utils/validate.js";

export default {
  name: "overSpeedAlarm",
  components: { e6Select },
  props: ["alarmSetId"],
  data() {
    return {
      loadingState: false,
      vehicleTreeList: [],
      advancedSettingShow: false,
      switchSettingBtnText: "打开高级设置",
      disabledByApply: false,
      dataInfo: {
        isHighSpeed: 1,
        judgePattern: 0,
        isLowSpeed: 0,
        hHighWaySpeed: "", // 高速路速度
        hFastRoadSpeed: "", // 快速路速度
        hGeneralRoadSpeed: "", // 普通路速度
        hContinueTime: "", // 持续时间
        dangerSpeed: "", // 危险速度
        alarmCommonAlarmSet: {
          isOverAll: 1,
          isApply: 1,
          isPlateformShow: 0,
          isAlarmSound: 0,
          isTerminalShow: 0,
          isPhoto: 0
        }
      },
      dataInfoRules: {
        hHighWaySpeed: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          {
            max: 4,
            message: "不可超过4位",
            trigger: ["blur", "change"]
          }
        ],
        hFastRoadSpeed: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          {
            max: 4,
            message: "不可超过4位",
            trigger: ["blur", "change"]
          }
        ],
        hGeneralRoadSpeed: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          {
            max: 4,
            message: "不可超过4位",
            trigger: ["blur", "change"]
          }
        ],
        hContinueTime: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          {
            max: 5,
            message: "不可超过5位",
            trigger: ["blur", "change"]
          }
        ],
        dangerSpeed: [
          { validator: validatorIntNum, trigger: ["blur"], required: true },
          {
            max: 4,
            message: "不可超过4位",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  methods: {
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //切换是否显示高级设置
    switchSetting() {
      this.advancedSettingShow = !this.advancedSettingShow;
      if (this.advancedSettingShow) {
        this.switchSettingBtnText = "收起高级设置";
      } else {
        this.switchSettingBtnText = "打开高级设置";
      }
    },
    //切换是否启用
    isApplyChange(value) {
      if (value === 1) {
        this.disabledByApply = false;
      } else {
        this.disabledByApply = true;
      }
    },
    /**
     * 保存超速报警设置
     */
    addData() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false;
        }
        if (this.alarmSetId == 0) {
          //新增参数名:
          this.dataInfo.vehicleIdList = this.getVehicleIdListParam();
          this.FetchSaveOverSpeedAlarmSet(this.dataInfo);
        } else {
          //修改
          this.FetchUpdateOverSpeedAlarmSet(this.dataInfo);
        }
      });
    },
    //新增
    FetchSaveOverSpeedAlarmSet(data) {
      this.loadingState = true;
      FetchSaveOverSpeedAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    //修改
    FetchUpdateOverSpeedAlarmSet(data) {
      this.loadingState = true;
      FetchUpdateOverSpeedAlarmSet(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
          this.loadingState = false;
        });
    },
    // 新增、修改完成时的回调函数
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 1000,
        onClose: () => {
          if (type === "success") {
            this.$router.push("/alarmSetCommonAlarmSetList");
          }
          this.loadingState = false;
        }
      });
    },
    //根据ID获取设置信息
    FetchFindOverSpeedAlarmById(data) {
      FetchFindOverSpeedAlarmById(data)
        .then(response => {
          if (response.result) {
            this.dataInfo = response.result;
            this.dataInfo.hHighWaySpeed || this.dataInfo.hHighWaySpeed === 0
              ? (this.dataInfo.hHighWaySpeed += "")
              : "";
            this.dataInfo.hFastRoadSpeed || this.dataInfo.hFastRoadSpeed === 0
              ? (this.dataInfo.hFastRoadSpeed += "")
              : "";
            this.dataInfo.hGeneralRoadSpeed || this.dataInfo.hGeneralRoadSpeed === 0
              ? (this.dataInfo.hGeneralRoadSpeed += "")
              : "";
            this.dataInfo.hContinueTime || this.dataInfo.hContinueTime === 0
              ? (this.dataInfo.hContinueTime += "")
              : "";
            this.dataInfo.dangerSpeed || this.dataInfo.dangerSpeed === 0
              ? (this.dataInfo.dangerSpeed += "")
              : "";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 取消
    cancelSubmit() {
      this.$router.push("/alarmSetCommonAlarmSetList");
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.e6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    }
  },
  computed: {
    radioLabel0() {
      return 0;
    },
    radioLabel1() {
      return 1;
    },
    radioLabel2() {
      return 2;
    }
  },
  mounted() {
    //初始化车辆树
    this.initVehicleTree();
    if (this.alarmSetId != 0) {
      //根据ID查询报警信息
      this.FetchFindOverSpeedAlarmById({ alarmSetId: this.alarmSetId });
    }
  }
};
</script>

<style scoped>
@import "./../../../assets/css/commonAlarm/edit.css"; /*引入公共样式*/
</style>
